import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import TatService from "services/tatService";

export const initialState = {
  list: [],
  loading: false,
  errorMessages: [],
  showMessage: false,
};

export const fetchTatDatas = createAsyncThunk(
  "/fetchTatDatas",
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await TatService.fetch(queryParams);
      var code = response.code;
      return {
        code: code,
        datas: response.data,
      };
    } catch (err) {
      let code = err.response?.data.code;
      let response = err.response;
      return rejectWithValue({
        code: code,
        errorMessages: response?.data?.message || "Error",
      });
    }
  }
);

export const tatSlice = createSlice({
  name: "tat",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = !state.loading;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTatDatas.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTatDatas.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.datas;
      })
      .addCase(fetchTatDatas.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = tatSlice.actions;

export default tatSlice.reducer;
